// extracted by mini-css-extract-plugin
export default {"container":"styles_container__msE7x","content":"styles_content__qTA3W"};